import { useEffect } from 'react';
import { tagTypeService } from 'js/services/tagType.service';
import { insertTrackableHTML } from 'js/utils/DOM.util';
import { TAG_TYPE } from 'js/components/system/TagManager/constants';

const headHtml = gtmId => `${'<script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({\'gtm.start\':\n'
    + 'new Date().getTime(),event:\'gtm.js\'});var f=d.getElementsByTagName(s)[0],\n'
    + 'j=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';j.async=true;j.src=\n'
    + '\'https://www.googletagmanager.com/gtm.js?id=\'+i+dl;f.parentNode.insertBefore(j,f);\n'
    + '})(window,document,\'script\',\'dataLayer\',\''}${gtmId}');</script>\n`;

const bodyHtml = gtmId => `<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"\n`
    + 'height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>';

export const GoogleTagManager = ({ config, tagName }) => {
    const { gtmId } = config;

    useEffect(() => {
        if (gtmId === '') {
            return;
        }

        return insertTrackableHTML({ selector: 'head', html: headHtml(gtmId),
            tagName, wrapperComment: 'Google Tag Manager'
        });
    }, [gtmId, tagName]);

    useEffect(() => {
        if (gtmId === '') {
            return;
        }

        return insertTrackableHTML({ selector: 'body', html: bodyHtml(gtmId),
            tagName, wrapperComment: 'Google Tag Manager (noscript)'
        });
    }, [gtmId, tagName]);

    return null;
};

tagTypeService.registerTagType({ [TAG_TYPE.googleTagManager]: GoogleTagManager });
